const API_ENDPOINT = 'https://arcane-bastion-72484.herokuapp.com/api';
const GOOGLE_CLIENT_ID = '70428371004-nsjuc02pvd1lj3iooo72ulc9e6qtpqod.apps.googleusercontent.com';
const serverURL = 'https://arcane-bastion-72484.herokuapp.com';
// const serverURL = 'http://localhost:8001';
const GOOGLE_API_KEY = 'AIzaSyBri0PKsTN8-kTlzAROVisAsALmAryij_A';

module.exports = {
  API_ENDPOINT,
  GOOGLE_CLIENT_ID,
  GOOGLE_API_KEY,
  serverURL,
};
